export const registerServiceWorker = () => navigator.serviceWorker.register('service-worker.js');
